import { render, staticRenderFns } from "./topbar-menu.vue?vue&type=template&id=5865da14"
import script from "./topbar-menu.vue?vue&type=script&lang=js"
export * from "./topbar-menu.vue?vue&type=script&lang=js"
import style0 from "./topbar-menu.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/topbar/topbar-menu.vue
// module id = OvId
// module chunks = 0